import Terminal from "./components/Terminal";
import './index.css';
function App() {

    return (
        <Terminal/>
    );
}

export default App;